import { AppOptions, IAppOptionsService } from '../../../index.d'
import { Api } from '../../api'

export class AppOptionsService implements IAppOptionsService {
  /**
   * Get app options data from api
   */
  async getAppOptions(): Promise<AppOptions> {
    const result = await Api.get<AppOptions>(`/api/app_options`)

    return result.data
  }
}
